module.exports = __webpack_public_path__ + "static/media/beetzmax-1.28aa09f4.jpg";